import { jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { atoms } from "../../css/atoms/atoms.mjs";
import { useLinkComponent } from "../ThemeProvider/ThemeProvider.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const Link = forwardRef(
  ({ href, className, data, ...restProps }, ref) => {
    const LinkComponent = useLinkComponent(ref);
    return /* @__PURE__ */ jsx(
      LinkComponent,
      {
        ref,
        href,
        className: clsx(atoms({ reset: "a" }), className),
        ...restProps,
        ...buildDataAttributes({ data, validateRestProps: false })
      }
    );
  }
);
Link.displayName = "Link";
export {
  Link
};
